/* eslint-disable @stripe-internal/embedded/no-restricted-globals */
import React from 'react';
import {safeWindowOpen} from '@stripe-internal/safe-links';
import {removeSearchParam} from '../../utils/removeSearchParam';

export type IPlatformFrameContext = {
  copyTextToClipboard: (text: string) => void;
  reloadWindow: () => void;
  removeSearchParam: (param: string) => void;
  redirectWindow: (url: string) => void;
};

const defaultPlatformFrameContext: IPlatformFrameContext = {
  copyTextToClipboard: (text) => {
    navigator.clipboard.writeText(text);
  },
  reloadWindow: () => {
    window.location.reload();
  },
  removeSearchParam,
  redirectWindow: (text) => {
    // safeWindowOpen ensures that window.opener is always null to protect against phishing attacks - RUN_CAUI-1762
    safeWindowOpen(text, '_blank');
  },
};

// This context is used for calling functions to execute Javascript on the platform frame.
// This is relevant for embedded components when rendered in an iframe.
export const PlatformFrameContext = React.createContext<
  IPlatformFrameContext | undefined
>(defaultPlatformFrameContext);
PlatformFrameContext.displayName = 'PlatformFrameContext';

export const usePlatformFrameContext = () => {
  const context = React.useContext(PlatformFrameContext);
  if (!context) {
    return defaultPlatformFrameContext;
  }
  return context;
};
